// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v2.6.1
//   protoc               unknown
// source: models/global.proto

/* eslint-disable */
import { BinaryReader, BinaryWriter } from "@bufbuild/protobuf/wire";

export const protobufPackage = "models";

/** AdminState defines an enumeration for object's administrative states. */
export enum AdminState {
  /** STATE_UNSPECIFIED - Invalid object state. */
  STATE_UNSPECIFIED = 0,
  /** ENABLED - Object is in enabled or active state. */
  ENABLED = 1,
  /** DISABLED - Object is in disabled or suspended state. */
  DISABLED = 2,
  /** DELETED - Object is in deleted state. */
  DELETED = 3,
  /** PENDING - Object is in pending state. */
  PENDING = 4,
  UNRECOGNIZED = -1,
}

export function adminStateFromJSON(object: any): AdminState {
  switch (object) {
    case 0:
    case "STATE_UNSPECIFIED":
      return AdminState.STATE_UNSPECIFIED;
    case 1:
    case "ENABLED":
      return AdminState.ENABLED;
    case 2:
    case "DISABLED":
      return AdminState.DISABLED;
    case 3:
    case "DELETED":
      return AdminState.DELETED;
    case 4:
    case "PENDING":
      return AdminState.PENDING;
    case -1:
    case "UNRECOGNIZED":
    default:
      return AdminState.UNRECOGNIZED;
  }
}

export function adminStateToJSON(object: AdminState): string {
  switch (object) {
    case AdminState.STATE_UNSPECIFIED:
      return "STATE_UNSPECIFIED";
    case AdminState.ENABLED:
      return "ENABLED";
    case AdminState.DISABLED:
      return "DISABLED";
    case AdminState.DELETED:
      return "DELETED";
    case AdminState.PENDING:
      return "PENDING";
    case AdminState.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

/** ApplicationType defines an enumeration for different applications. */
export enum ApplicationType {
  /** APPLICATION_UNSPECIFIED - Unspecified application. */
  APPLICATION_UNSPECIFIED = 0,
  /** SEXTANT - Sextant application. */
  SEXTANT = 1,
  /** BILGE - Bilge application. */
  BILGE = 2,
  /** CONFIGD - Configd application. */
  CONFIGD = 3,
  /** BRIG - Brig application. */
  BRIG = 4,
  /** MIZZEN - Mizzen application. */
  MIZZEN = 5,
  /** RUDDER - Rudder application. */
  RUDDER = 6,
  /** FRED - Fred application. */
  FRED = 7,
  /** GINGER - Ginger application. */
  GINGER = 8,
  UNRECOGNIZED = -1,
}

export function applicationTypeFromJSON(object: any): ApplicationType {
  switch (object) {
    case 0:
    case "APPLICATION_UNSPECIFIED":
      return ApplicationType.APPLICATION_UNSPECIFIED;
    case 1:
    case "SEXTANT":
      return ApplicationType.SEXTANT;
    case 2:
    case "BILGE":
      return ApplicationType.BILGE;
    case 3:
    case "CONFIGD":
      return ApplicationType.CONFIGD;
    case 4:
    case "BRIG":
      return ApplicationType.BRIG;
    case 5:
    case "MIZZEN":
      return ApplicationType.MIZZEN;
    case 6:
    case "RUDDER":
      return ApplicationType.RUDDER;
    case 7:
    case "FRED":
      return ApplicationType.FRED;
    case 8:
    case "GINGER":
      return ApplicationType.GINGER;
    case -1:
    case "UNRECOGNIZED":
    default:
      return ApplicationType.UNRECOGNIZED;
  }
}

export function applicationTypeToJSON(object: ApplicationType): string {
  switch (object) {
    case ApplicationType.APPLICATION_UNSPECIFIED:
      return "APPLICATION_UNSPECIFIED";
    case ApplicationType.SEXTANT:
      return "SEXTANT";
    case ApplicationType.BILGE:
      return "BILGE";
    case ApplicationType.CONFIGD:
      return "CONFIGD";
    case ApplicationType.BRIG:
      return "BRIG";
    case ApplicationType.MIZZEN:
      return "MIZZEN";
    case ApplicationType.RUDDER:
      return "RUDDER";
    case ApplicationType.FRED:
      return "FRED";
    case ApplicationType.GINGER:
      return "GINGER";
    case ApplicationType.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

/**
 * AttestationType identifies how the requester of a device identity
 * certificate was attested at issuance time. Recorded on each
 * auth.device_cert_audit row.
 */
export enum AttestationType {
  ATTESTATION_TYPE_UNSPECIFIED = 0,
  /** ATTESTATION_TYPE_NONE - No device attestation (admin or one-step onboard caller). */
  ATTESTATION_TYPE_NONE = 1,
  /** ATTESTATION_TYPE_TPM_SUDI - TPM-backed SUDI attestation (e.g. UCSC-C225, UCS-845A). */
  ATTESTATION_TYPE_TPM_SUDI = 2,
  /** ATTESTATION_TYPE_HARDWARE_SUDI - Classic hardware SUDI attestation (TAM-managed key on the device). */
  ATTESTATION_TYPE_HARDWARE_SUDI = 3,
  UNRECOGNIZED = -1,
}

export function attestationTypeFromJSON(object: any): AttestationType {
  switch (object) {
    case 0:
    case "ATTESTATION_TYPE_UNSPECIFIED":
      return AttestationType.ATTESTATION_TYPE_UNSPECIFIED;
    case 1:
    case "ATTESTATION_TYPE_NONE":
      return AttestationType.ATTESTATION_TYPE_NONE;
    case 2:
    case "ATTESTATION_TYPE_TPM_SUDI":
      return AttestationType.ATTESTATION_TYPE_TPM_SUDI;
    case 3:
    case "ATTESTATION_TYPE_HARDWARE_SUDI":
      return AttestationType.ATTESTATION_TYPE_HARDWARE_SUDI;
    case -1:
    case "UNRECOGNIZED":
    default:
      return AttestationType.UNRECOGNIZED;
  }
}

export function attestationTypeToJSON(object: AttestationType): string {
  switch (object) {
    case AttestationType.ATTESTATION_TYPE_UNSPECIFIED:
      return "ATTESTATION_TYPE_UNSPECIFIED";
    case AttestationType.ATTESTATION_TYPE_NONE:
      return "ATTESTATION_TYPE_NONE";
    case AttestationType.ATTESTATION_TYPE_TPM_SUDI:
      return "ATTESTATION_TYPE_TPM_SUDI";
    case AttestationType.ATTESTATION_TYPE_HARDWARE_SUDI:
      return "ATTESTATION_TYPE_HARDWARE_SUDI";
    case AttestationType.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

/** BoolType defines a nullable boolean type. */
export enum BoolType {
  /** BOOL_UNSPECIFIED - Unspecified or undefined boolean. */
  BOOL_UNSPECIFIED = 0,
  /** BOOL_FALSE - Boolean value of false. */
  BOOL_FALSE = 1,
  /** BOOL_TRUE - Boolean value of true. */
  BOOL_TRUE = 2,
  UNRECOGNIZED = -1,
}

export function boolTypeFromJSON(object: any): BoolType {
  switch (object) {
    case 0:
    case "BOOL_UNSPECIFIED":
      return BoolType.BOOL_UNSPECIFIED;
    case 1:
    case "BOOL_FALSE":
      return BoolType.BOOL_FALSE;
    case 2:
    case "BOOL_TRUE":
      return BoolType.BOOL_TRUE;
    case -1:
    case "UNRECOGNIZED":
    default:
      return BoolType.UNRECOGNIZED;
  }
}

export function boolTypeToJSON(object: BoolType): string {
  switch (object) {
    case BoolType.BOOL_UNSPECIFIED:
      return "BOOL_UNSPECIFIED";
    case BoolType.BOOL_FALSE:
      return "BOOL_FALSE";
    case BoolType.BOOL_TRUE:
      return "BOOL_TRUE";
    case BoolType.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

/** CachePartition defines an enumeration of the cache partition names on a device */
export enum CachePartition {
  /** CACHE_PARTITION_UNSPECIFIED - Unspecified partition location */
  CACHE_PARTITION_UNSPECIFIED = 0,
  /** PARTITION_A - Cache partition A */
  PARTITION_A = 1,
  /** PARTITION_B - Cache partition B */
  PARTITION_B = 2,
  UNRECOGNIZED = -1,
}

export function cachePartitionFromJSON(object: any): CachePartition {
  switch (object) {
    case 0:
    case "CACHE_PARTITION_UNSPECIFIED":
      return CachePartition.CACHE_PARTITION_UNSPECIFIED;
    case 1:
    case "PARTITION_A":
      return CachePartition.PARTITION_A;
    case 2:
    case "PARTITION_B":
      return CachePartition.PARTITION_B;
    case -1:
    case "UNRECOGNIZED":
    default:
      return CachePartition.UNRECOGNIZED;
  }
}

export function cachePartitionToJSON(object: CachePartition): string {
  switch (object) {
    case CachePartition.CACHE_PARTITION_UNSPECIFIED:
      return "CACHE_PARTITION_UNSPECIFIED";
    case CachePartition.PARTITION_A:
      return "PARTITION_A";
    case CachePartition.PARTITION_B:
      return "PARTITION_B";
    case CachePartition.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

/** Certificate type that is being requested. */
export enum CertType {
  /** CERT_TYPE_UNSPECIFIED - Certificate type unspecified. */
  CERT_TYPE_UNSPECIFIED = 0,
  /** CERT_TYPE_SUB_CA - Certificate to certify a sub-ca. */
  CERT_TYPE_SUB_CA = 1,
  /** CERT_TYPE_DEVICE - Certificate to certify a device. */
  CERT_TYPE_DEVICE = 2,
  /** CERT_TYPE_VIRTUAL_DEVICE - Certificate to certify a virtual device. */
  CERT_TYPE_VIRTUAL_DEVICE = 3,
  UNRECOGNIZED = -1,
}

export function certTypeFromJSON(object: any): CertType {
  switch (object) {
    case 0:
    case "CERT_TYPE_UNSPECIFIED":
      return CertType.CERT_TYPE_UNSPECIFIED;
    case 1:
    case "CERT_TYPE_SUB_CA":
      return CertType.CERT_TYPE_SUB_CA;
    case 2:
    case "CERT_TYPE_DEVICE":
      return CertType.CERT_TYPE_DEVICE;
    case 3:
    case "CERT_TYPE_VIRTUAL_DEVICE":
      return CertType.CERT_TYPE_VIRTUAL_DEVICE;
    case -1:
    case "UNRECOGNIZED":
    default:
      return CertType.UNRECOGNIZED;
  }
}

export function certTypeToJSON(object: CertType): string {
  switch (object) {
    case CertType.CERT_TYPE_UNSPECIFIED:
      return "CERT_TYPE_UNSPECIFIED";
    case CertType.CERT_TYPE_SUB_CA:
      return "CERT_TYPE_SUB_CA";
    case CertType.CERT_TYPE_DEVICE:
      return "CERT_TYPE_DEVICE";
    case CertType.CERT_TYPE_VIRTUAL_DEVICE:
      return "CERT_TYPE_VIRTUAL_DEVICE";
    case CertType.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

/** ClaimMode defines an enumeration of the device claim mode. */
export enum ClaimMode {
  /** CLAIM_MODE_UNSPECIFIED - Unspecified claim mode. */
  CLAIM_MODE_UNSPECIFIED = 0,
  /** CLAIM_MODE_CLAIM_CODE - Claiming device via claim code */
  CLAIM_MODE_CLAIM_CODE = 1,
  /** CLAIM_MODE_SPIDER_CLAIM - Claiming device via spider claim, having adjacency to the claimed device */
  CLAIM_MODE_SPIDER_CLAIM = 2,
  /** CLAIM_MODE_USB_TOKEN_CLAIM - Claiming device via USB token */
  CLAIM_MODE_USB_TOKEN_CLAIM = 3,
  UNRECOGNIZED = -1,
}

export function claimModeFromJSON(object: any): ClaimMode {
  switch (object) {
    case 0:
    case "CLAIM_MODE_UNSPECIFIED":
      return ClaimMode.CLAIM_MODE_UNSPECIFIED;
    case 1:
    case "CLAIM_MODE_CLAIM_CODE":
      return ClaimMode.CLAIM_MODE_CLAIM_CODE;
    case 2:
    case "CLAIM_MODE_SPIDER_CLAIM":
      return ClaimMode.CLAIM_MODE_SPIDER_CLAIM;
    case 3:
    case "CLAIM_MODE_USB_TOKEN_CLAIM":
      return ClaimMode.CLAIM_MODE_USB_TOKEN_CLAIM;
    case -1:
    case "UNRECOGNIZED":
    default:
      return ClaimMode.UNRECOGNIZED;
  }
}

export function claimModeToJSON(object: ClaimMode): string {
  switch (object) {
    case ClaimMode.CLAIM_MODE_UNSPECIFIED:
      return "CLAIM_MODE_UNSPECIFIED";
    case ClaimMode.CLAIM_MODE_CLAIM_CODE:
      return "CLAIM_MODE_CLAIM_CODE";
    case ClaimMode.CLAIM_MODE_SPIDER_CLAIM:
      return "CLAIM_MODE_SPIDER_CLAIM";
    case ClaimMode.CLAIM_MODE_USB_TOKEN_CLAIM:
      return "CLAIM_MODE_USB_TOKEN_CLAIM";
    case ClaimMode.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

/** ClaimStatus defines an enumeration of the possible outcomes when attempting to claim a device. */
export enum ClaimStatus {
  /** CLAIM_STATUS_UNSPECIFIED - Unspecified claim error (there was no error). */
  CLAIM_STATUS_UNSPECIFIED = 0,
  /** CLAIM_STATUS_SUCCESS - Successfully claimed device. */
  CLAIM_STATUS_SUCCESS = 1,
  /** CLAIM_STATUS_ALREADY_CLAIMED - Device has been claimed already. */
  CLAIM_STATUS_ALREADY_CLAIMED = 2,
  /** CLAIM_STATUS_INVALID_CODE - The claim code provided is invalid (non-existent, malformed, etc). */
  CLAIM_STATUS_INVALID_CODE = 3,
  /** CLAIM_STATUS_EXPIRED_CODE - Expired claim code. */
  CLAIM_STATUS_EXPIRED_CODE = 4,
  /** CLAIM_STATUS_REJECT_CLAIM - The claim has been rejected. */
  CLAIM_STATUS_REJECT_CLAIM = 5,
  /** CLAIM_STATUS_INTERNAL_ERR - There is an internal err during claim. */
  CLAIM_STATUS_INTERNAL_ERR = 6,
  UNRECOGNIZED = -1,
}

export function claimStatusFromJSON(object: any): ClaimStatus {
  switch (object) {
    case 0:
    case "CLAIM_STATUS_UNSPECIFIED":
      return ClaimStatus.CLAIM_STATUS_UNSPECIFIED;
    case 1:
    case "CLAIM_STATUS_SUCCESS":
      return ClaimStatus.CLAIM_STATUS_SUCCESS;
    case 2:
    case "CLAIM_STATUS_ALREADY_CLAIMED":
      return ClaimStatus.CLAIM_STATUS_ALREADY_CLAIMED;
    case 3:
    case "CLAIM_STATUS_INVALID_CODE":
      return ClaimStatus.CLAIM_STATUS_INVALID_CODE;
    case 4:
    case "CLAIM_STATUS_EXPIRED_CODE":
      return ClaimStatus.CLAIM_STATUS_EXPIRED_CODE;
    case 5:
    case "CLAIM_STATUS_REJECT_CLAIM":
      return ClaimStatus.CLAIM_STATUS_REJECT_CLAIM;
    case 6:
    case "CLAIM_STATUS_INTERNAL_ERR":
      return ClaimStatus.CLAIM_STATUS_INTERNAL_ERR;
    case -1:
    case "UNRECOGNIZED":
    default:
      return ClaimStatus.UNRECOGNIZED;
  }
}

export function claimStatusToJSON(object: ClaimStatus): string {
  switch (object) {
    case ClaimStatus.CLAIM_STATUS_UNSPECIFIED:
      return "CLAIM_STATUS_UNSPECIFIED";
    case ClaimStatus.CLAIM_STATUS_SUCCESS:
      return "CLAIM_STATUS_SUCCESS";
    case ClaimStatus.CLAIM_STATUS_ALREADY_CLAIMED:
      return "CLAIM_STATUS_ALREADY_CLAIMED";
    case ClaimStatus.CLAIM_STATUS_INVALID_CODE:
      return "CLAIM_STATUS_INVALID_CODE";
    case ClaimStatus.CLAIM_STATUS_EXPIRED_CODE:
      return "CLAIM_STATUS_EXPIRED_CODE";
    case ClaimStatus.CLAIM_STATUS_REJECT_CLAIM:
      return "CLAIM_STATUS_REJECT_CLAIM";
    case ClaimStatus.CLAIM_STATUS_INTERNAL_ERR:
      return "CLAIM_STATUS_INTERNAL_ERR";
    case ClaimStatus.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

/** Criticality defines an enumeration of activity event criticalities. */
export enum Criticality {
  /** CRITICALITY_UNSPECIFIED - Unspecified criticality. */
  CRITICALITY_UNSPECIFIED = 0,
  /** EMERGENCY - System is unusable. */
  EMERGENCY = 1,
  /** ALERT - Action must be taken immediately. */
  ALERT = 2,
  /** CRITICAL - Critical conditions. */
  CRITICAL = 3,
  /** ERROR - Error conditions. */
  ERROR = 4,
  /** WARNING - Warning conditions. */
  WARNING = 5,
  /** NOTICE - Normal, but significant, condition. */
  NOTICE = 6,
  /** INFO - Informational message. */
  INFO = 7,
  /** DEBUG - Debug level message. */
  DEBUG = 8,
  UNRECOGNIZED = -1,
}

export function criticalityFromJSON(object: any): Criticality {
  switch (object) {
    case 0:
    case "CRITICALITY_UNSPECIFIED":
      return Criticality.CRITICALITY_UNSPECIFIED;
    case 1:
    case "EMERGENCY":
      return Criticality.EMERGENCY;
    case 2:
    case "ALERT":
      return Criticality.ALERT;
    case 3:
    case "CRITICAL":
      return Criticality.CRITICAL;
    case 4:
    case "ERROR":
      return Criticality.ERROR;
    case 5:
    case "WARNING":
      return Criticality.WARNING;
    case 6:
    case "NOTICE":
      return Criticality.NOTICE;
    case 7:
    case "INFO":
      return Criticality.INFO;
    case 8:
    case "DEBUG":
      return Criticality.DEBUG;
    case -1:
    case "UNRECOGNIZED":
    default:
      return Criticality.UNRECOGNIZED;
  }
}

export function criticalityToJSON(object: Criticality): string {
  switch (object) {
    case Criticality.CRITICALITY_UNSPECIFIED:
      return "CRITICALITY_UNSPECIFIED";
    case Criticality.EMERGENCY:
      return "EMERGENCY";
    case Criticality.ALERT:
      return "ALERT";
    case Criticality.CRITICAL:
      return "CRITICAL";
    case Criticality.ERROR:
      return "ERROR";
    case Criticality.WARNING:
      return "WARNING";
    case Criticality.NOTICE:
      return "NOTICE";
    case Criticality.INFO:
      return "INFO";
    case Criticality.DEBUG:
      return "DEBUG";
    case Criticality.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

/** DataType defines an enumeration of data types. */
export enum DataType {
  /** DATA_TYPE_UNSPECIFIED - Unspecified data type. */
  DATA_TYPE_UNSPECIFIED = 0,
  /** STRING - String type. */
  STRING = 1,
  /** INT32 - 32-bit signed integer. */
  INT32 = 2,
  /** UINT32 - 32-bit unsigned integer. */
  UINT32 = 3,
  /** INT64 - 64-bit signed integer. */
  INT64 = 4,
  /** UINT64 - 64-bit unsigned integer. */
  UINT64 = 5,
  /** BOOL - Boolean value. */
  BOOL = 6,
  /** TIME - Time value in ISO-8601 format. */
  TIME = 7,
  /** UUID - UUID value. */
  UUID = 8,
  /** DURATION - Duration value. */
  DURATION = 9,
  /** JSON - JSON data. */
  JSON = 10,
  UNRECOGNIZED = -1,
}

export function dataTypeFromJSON(object: any): DataType {
  switch (object) {
    case 0:
    case "DATA_TYPE_UNSPECIFIED":
      return DataType.DATA_TYPE_UNSPECIFIED;
    case 1:
    case "STRING":
      return DataType.STRING;
    case 2:
    case "INT32":
      return DataType.INT32;
    case 3:
    case "UINT32":
      return DataType.UINT32;
    case 4:
    case "INT64":
      return DataType.INT64;
    case 5:
    case "UINT64":
      return DataType.UINT64;
    case 6:
    case "BOOL":
      return DataType.BOOL;
    case 7:
    case "TIME":
      return DataType.TIME;
    case 8:
    case "UUID":
      return DataType.UUID;
    case 9:
    case "DURATION":
      return DataType.DURATION;
    case 10:
    case "JSON":
      return DataType.JSON;
    case -1:
    case "UNRECOGNIZED":
    default:
      return DataType.UNRECOGNIZED;
  }
}

export function dataTypeToJSON(object: DataType): string {
  switch (object) {
    case DataType.DATA_TYPE_UNSPECIFIED:
      return "DATA_TYPE_UNSPECIFIED";
    case DataType.STRING:
      return "STRING";
    case DataType.INT32:
      return "INT32";
    case DataType.UINT32:
      return "UINT32";
    case DataType.INT64:
      return "INT64";
    case DataType.UINT64:
      return "UINT64";
    case DataType.BOOL:
      return "BOOL";
    case DataType.TIME:
      return "TIME";
    case DataType.UUID:
      return "UUID";
    case DataType.DURATION:
      return "DURATION";
    case DataType.JSON:
      return "JSON";
    case DataType.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

/** Duration defines an enumeration of time durations. */
export enum Duration {
  /** DURATION_UNSPECIFIED - Unspecified duration. */
  DURATION_UNSPECIFIED = 0,
  /** SECOND - Seconds. */
  SECOND = 1,
  /** MINUTE - Minutes. */
  MINUTE = 3,
  /** HOUR - Hours. */
  HOUR = 4,
  /** DAY - Days. */
  DAY = 5,
  /** WEEK - Weeks. */
  WEEK = 6,
  /** MONTH - Months. */
  MONTH = 7,
  /** YEAR - Years. */
  YEAR = 8,
  UNRECOGNIZED = -1,
}

export function durationFromJSON(object: any): Duration {
  switch (object) {
    case 0:
    case "DURATION_UNSPECIFIED":
      return Duration.DURATION_UNSPECIFIED;
    case 1:
    case "SECOND":
      return Duration.SECOND;
    case 3:
    case "MINUTE":
      return Duration.MINUTE;
    case 4:
    case "HOUR":
      return Duration.HOUR;
    case 5:
    case "DAY":
      return Duration.DAY;
    case 6:
    case "WEEK":
      return Duration.WEEK;
    case 7:
    case "MONTH":
      return Duration.MONTH;
    case 8:
    case "YEAR":
      return Duration.YEAR;
    case -1:
    case "UNRECOGNIZED":
    default:
      return Duration.UNRECOGNIZED;
  }
}

export function durationToJSON(object: Duration): string {
  switch (object) {
    case Duration.DURATION_UNSPECIFIED:
      return "DURATION_UNSPECIFIED";
    case Duration.SECOND:
      return "SECOND";
    case Duration.MINUTE:
      return "MINUTE";
    case Duration.HOUR:
      return "HOUR";
    case Duration.DAY:
      return "DAY";
    case Duration.WEEK:
      return "WEEK";
    case Duration.MONTH:
      return "MONTH";
    case Duration.YEAR:
      return "YEAR";
    case Duration.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

/** An entitlement level governs the extent to which a user can configure a fabric. */
export enum EntitlementLevel {
  ENTITLEMENT_LEVEL_UNSPECIFIED = 0,
  ESSENTIALS = 10,
  ADVANTAGE = 20,
  PREMIER = 30,
  UNRECOGNIZED = -1,
}

export function entitlementLevelFromJSON(object: any): EntitlementLevel {
  switch (object) {
    case 0:
    case "ENTITLEMENT_LEVEL_UNSPECIFIED":
      return EntitlementLevel.ENTITLEMENT_LEVEL_UNSPECIFIED;
    case 10:
    case "ESSENTIALS":
      return EntitlementLevel.ESSENTIALS;
    case 20:
    case "ADVANTAGE":
      return EntitlementLevel.ADVANTAGE;
    case 30:
    case "PREMIER":
      return EntitlementLevel.PREMIER;
    case -1:
    case "UNRECOGNIZED":
    default:
      return EntitlementLevel.UNRECOGNIZED;
  }
}

export function entitlementLevelToJSON(object: EntitlementLevel): string {
  switch (object) {
    case EntitlementLevel.ENTITLEMENT_LEVEL_UNSPECIFIED:
      return "ENTITLEMENT_LEVEL_UNSPECIFIED";
    case EntitlementLevel.ESSENTIALS:
      return "ESSENTIALS";
    case EntitlementLevel.ADVANTAGE:
      return "ADVANTAGE";
    case EntitlementLevel.PREMIER:
      return "PREMIER";
    case EntitlementLevel.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

/** EntitlementUsageType defines how entitlement usage is calculated and reported. */
export enum EntitlementUsageType {
  /** ENTITLEMENT_USAGE_TYPE_UNSPECIFIED - Unspecified usage type, defaults to by fabric. */
  ENTITLEMENT_USAGE_TYPE_UNSPECIFIED = 0,
  /** ENTITLEMENT_USAGE_TYPE_BY_FABRIC - Calculate entitlement usage grouped by fabric. */
  ENTITLEMENT_USAGE_TYPE_BY_FABRIC = 1,
  /** ENTITLEMENT_USAGE_TYPE_BY_PID - Calculate entitlement usage grouped by product ID (PID). */
  ENTITLEMENT_USAGE_TYPE_BY_PID = 2,
  UNRECOGNIZED = -1,
}

export function entitlementUsageTypeFromJSON(object: any): EntitlementUsageType {
  switch (object) {
    case 0:
    case "ENTITLEMENT_USAGE_TYPE_UNSPECIFIED":
      return EntitlementUsageType.ENTITLEMENT_USAGE_TYPE_UNSPECIFIED;
    case 1:
    case "ENTITLEMENT_USAGE_TYPE_BY_FABRIC":
      return EntitlementUsageType.ENTITLEMENT_USAGE_TYPE_BY_FABRIC;
    case 2:
    case "ENTITLEMENT_USAGE_TYPE_BY_PID":
      return EntitlementUsageType.ENTITLEMENT_USAGE_TYPE_BY_PID;
    case -1:
    case "UNRECOGNIZED":
    default:
      return EntitlementUsageType.UNRECOGNIZED;
  }
}

export function entitlementUsageTypeToJSON(object: EntitlementUsageType): string {
  switch (object) {
    case EntitlementUsageType.ENTITLEMENT_USAGE_TYPE_UNSPECIFIED:
      return "ENTITLEMENT_USAGE_TYPE_UNSPECIFIED";
    case EntitlementUsageType.ENTITLEMENT_USAGE_TYPE_BY_FABRIC:
      return "ENTITLEMENT_USAGE_TYPE_BY_FABRIC";
    case EntitlementUsageType.ENTITLEMENT_USAGE_TYPE_BY_PID:
      return "ENTITLEMENT_USAGE_TYPE_BY_PID";
    case EntitlementUsageType.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

/** FabricType defines an enumeration of fabric types. */
export enum FabricType {
  /** FABRIC_TYPE_UNSPECIFIED - Unspecified fabric type. */
  FABRIC_TYPE_UNSPECIFIED = 0,
  /** INVENTORY - Fabric is derived from inventory switches. */
  INVENTORY = 1,
  /** BLUEPRINT - Fabric is a blueprint fabric with linked switches. */
  BLUEPRINT = 2,
  /** PARKINGLOT - Fabric is a parking lot fabric with unbound switches. */
  PARKINGLOT = 3,
  UNRECOGNIZED = -1,
}

export function fabricTypeFromJSON(object: any): FabricType {
  switch (object) {
    case 0:
    case "FABRIC_TYPE_UNSPECIFIED":
      return FabricType.FABRIC_TYPE_UNSPECIFIED;
    case 1:
    case "INVENTORY":
      return FabricType.INVENTORY;
    case 2:
    case "BLUEPRINT":
      return FabricType.BLUEPRINT;
    case 3:
    case "PARKINGLOT":
      return FabricType.PARKINGLOT;
    case -1:
    case "UNRECOGNIZED":
    default:
      return FabricType.UNRECOGNIZED;
  }
}

export function fabricTypeToJSON(object: FabricType): string {
  switch (object) {
    case FabricType.FABRIC_TYPE_UNSPECIFIED:
      return "FABRIC_TYPE_UNSPECIFIED";
    case FabricType.INVENTORY:
      return "INVENTORY";
    case FabricType.BLUEPRINT:
      return "BLUEPRINT";
    case FabricType.PARKINGLOT:
      return "PARKINGLOT";
    case FabricType.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

/** Geo identifies a geographic region for org/cell placement. */
export enum Geo {
  /** GEO_UNSPECIFIED - Unspecified geo. */
  GEO_UNSPECIFIED = 0,
  /** NA - North America. */
  NA = 1,
  /** EU - Europe. */
  EU = 2,
  UNRECOGNIZED = -1,
}

export function geoFromJSON(object: any): Geo {
  switch (object) {
    case 0:
    case "GEO_UNSPECIFIED":
      return Geo.GEO_UNSPECIFIED;
    case 1:
    case "NA":
      return Geo.NA;
    case 2:
    case "EU":
      return Geo.EU;
    case -1:
    case "UNRECOGNIZED":
    default:
      return Geo.UNRECOGNIZED;
  }
}

export function geoToJSON(object: Geo): string {
  switch (object) {
    case Geo.GEO_UNSPECIFIED:
      return "GEO_UNSPECIFIED";
    case Geo.NA:
      return "NA";
    case Geo.EU:
      return "EU";
    case Geo.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

/** Indicates the availability of an image */
export enum ImageAvailabilityType {
  /** IMAGE_AVAILABILITY_TYPE_UNSPECIFIED - Unspecified image availability. */
  IMAGE_AVAILABILITY_TYPE_UNSPECIFIED = 0,
  /** IMAGE_AVAILABILITY_TYPE_ALL - Image is usable in all situations. */
  IMAGE_AVAILABILITY_TYPE_ALL = 1,
  /** IMAGE_AVAILABILITY_TYPE_LIMITED - Existing usage of this image is fine but new devices cannot be bound/upgraded to this image. */
  IMAGE_AVAILABILITY_TYPE_LIMITED = 2,
  /** IMAGE_AVAILABILITY_TYPE_NONE - Image should not be used. */
  IMAGE_AVAILABILITY_TYPE_NONE = 3,
  /** IMAGE_AVAILABILITY_TYPE_AGENT_ONLY - Agent upgrade only, no container upgrade needed. */
  IMAGE_AVAILABILITY_TYPE_AGENT_ONLY = 4,
  UNRECOGNIZED = -1,
}

export function imageAvailabilityTypeFromJSON(object: any): ImageAvailabilityType {
  switch (object) {
    case 0:
    case "IMAGE_AVAILABILITY_TYPE_UNSPECIFIED":
      return ImageAvailabilityType.IMAGE_AVAILABILITY_TYPE_UNSPECIFIED;
    case 1:
    case "IMAGE_AVAILABILITY_TYPE_ALL":
      return ImageAvailabilityType.IMAGE_AVAILABILITY_TYPE_ALL;
    case 2:
    case "IMAGE_AVAILABILITY_TYPE_LIMITED":
      return ImageAvailabilityType.IMAGE_AVAILABILITY_TYPE_LIMITED;
    case 3:
    case "IMAGE_AVAILABILITY_TYPE_NONE":
      return ImageAvailabilityType.IMAGE_AVAILABILITY_TYPE_NONE;
    case 4:
    case "IMAGE_AVAILABILITY_TYPE_AGENT_ONLY":
      return ImageAvailabilityType.IMAGE_AVAILABILITY_TYPE_AGENT_ONLY;
    case -1:
    case "UNRECOGNIZED":
    default:
      return ImageAvailabilityType.UNRECOGNIZED;
  }
}

export function imageAvailabilityTypeToJSON(object: ImageAvailabilityType): string {
  switch (object) {
    case ImageAvailabilityType.IMAGE_AVAILABILITY_TYPE_UNSPECIFIED:
      return "IMAGE_AVAILABILITY_TYPE_UNSPECIFIED";
    case ImageAvailabilityType.IMAGE_AVAILABILITY_TYPE_ALL:
      return "IMAGE_AVAILABILITY_TYPE_ALL";
    case ImageAvailabilityType.IMAGE_AVAILABILITY_TYPE_LIMITED:
      return "IMAGE_AVAILABILITY_TYPE_LIMITED";
    case ImageAvailabilityType.IMAGE_AVAILABILITY_TYPE_NONE:
      return "IMAGE_AVAILABILITY_TYPE_NONE";
    case ImageAvailabilityType.IMAGE_AVAILABILITY_TYPE_AGENT_ONLY:
      return "IMAGE_AVAILABILITY_TYPE_AGENT_ONLY";
    case ImageAvailabilityType.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

/** InvitationStatus defines the status of an organization invitation. */
export enum InvitationStatus {
  /** INVITATION_STATUS_UNSPECIFIED - Unspecified invitation status. */
  INVITATION_STATUS_UNSPECIFIED = 0,
  /** INVITATION_SENT - Invitation email has been sent. */
  INVITATION_SENT = 1,
  /** INVITATION_FAILED - Invitation email failed to send. */
  INVITATION_FAILED = 2,
  /** INVITATION_ACCEPTED - Invitation has been accepted by the recipient. */
  INVITATION_ACCEPTED = 3,
  /** INVITATION_REJECTED - Invitation has been rejected by the recipient. */
  INVITATION_REJECTED = 4,
  UNRECOGNIZED = -1,
}

export function invitationStatusFromJSON(object: any): InvitationStatus {
  switch (object) {
    case 0:
    case "INVITATION_STATUS_UNSPECIFIED":
      return InvitationStatus.INVITATION_STATUS_UNSPECIFIED;
    case 1:
    case "INVITATION_SENT":
      return InvitationStatus.INVITATION_SENT;
    case 2:
    case "INVITATION_FAILED":
      return InvitationStatus.INVITATION_FAILED;
    case 3:
    case "INVITATION_ACCEPTED":
      return InvitationStatus.INVITATION_ACCEPTED;
    case 4:
    case "INVITATION_REJECTED":
      return InvitationStatus.INVITATION_REJECTED;
    case -1:
    case "UNRECOGNIZED":
    default:
      return InvitationStatus.UNRECOGNIZED;
  }
}

export function invitationStatusToJSON(object: InvitationStatus): string {
  switch (object) {
    case InvitationStatus.INVITATION_STATUS_UNSPECIFIED:
      return "INVITATION_STATUS_UNSPECIFIED";
    case InvitationStatus.INVITATION_SENT:
      return "INVITATION_SENT";
    case InvitationStatus.INVITATION_FAILED:
      return "INVITATION_FAILED";
    case InvitationStatus.INVITATION_ACCEPTED:
      return "INVITATION_ACCEPTED";
    case InvitationStatus.INVITATION_REJECTED:
      return "INVITATION_REJECTED";
    case InvitationStatus.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

/**
 * ObjectType defines an enumeration of types of objects.
 *
 * INTERNAL
 *
 * By convention, ObjectType must have exact same string name (in uppercase)
 * as Go type name. For example, Go type Fabric must have an object type of
 * FABRIC.
 */
export enum ObjectType {
  /** OBJECT_UNSPECIFIED - Unspecified object type. */
  OBJECT_UNSPECIFIED = 0,
  /** USER - System user type. */
  USER = 1,
  /** TENANT - Tenant object type. */
  TENANT = 2,
  /** FABRIC - Fabric object type. */
  FABRIC = 3,
  /** NODE - Node object type. */
  NODE = 4,
  /** NETWORK_PORT - Network port type. */
  NETWORK_PORT = 5,
  /** PORT_CONNECTION - Network port connection. */
  PORT_CONNECTION = 6,
  /** VLAN - VLAN object type. */
  VLAN = 7,
  /** SVI - VLAN SVI object type. */
  SVI = 8,
  /** DHCP_RELAY - DHCP relay object type. */
  DHCP_RELAY = 9,
  /** VRF - Virtual routing and forwarding (VRF) type. */
  VRF = 10,
  /** STATIC_ROUTES - Static routes type. */
  STATIC_ROUTES = 11,
  /** PORT_CHANNEL - Port channel object type. */
  PORT_CHANNEL = 12,
  /** FABRIC_TRANSACTION - Fabric transaction type. */
  FABRIC_TRANSACTION = 13,
  /** ORGANIZATION - Organization type. */
  ORGANIZATION = 14,
  /** BEARER_TOKEN - Bearer token type. */
  BEARER_TOKEN = 15,
  /** API_KEY - API key type. */
  API_KEY = 16,
  /** REST_KEY - API public key type. */
  REST_KEY = 17,
  /** VNI - Logical network (VNI) type. */
  VNI = 18,
  /** MANAGEMENT_PORT - Ethernet management port type. */
  MANAGEMENT_PORT = 19,
  /** LOOPBACK - Loopback device type. */
  LOOPBACK = 20,
  /** SUB_INTERFACE - Sub-interface type. */
  SUB_INTERFACE = 21,
  /** PER_VLAN_STP - Per-VLAN spanning tree protocol type. */
  PER_VLAN_STP = 22,
  /** BGP_PEER - BGP peer config object type. */
  BGP_PEER = 23,
  /** PORT_BREAKOUT - Network port breakout config. */
  PORT_BREAKOUT = 24,
  /** BGP_POLICY - BGP peering policy config. */
  BGP_POLICY = 25,
  /** PREFIX_LIST - IP prefix list. */
  PREFIX_LIST = 26,
  /** DEVICE - Device object type. */
  DEVICE = 27,
  /** NOTIFICATION_ENDPOINT - Notification endpoint object type. */
  NOTIFICATION_ENDPOINT = 28,
  /** CERTIFICATES - Certificates object type. */
  CERTIFICATES = 29,
  /** FABRIC_IMAGE_UPDATE - FabricImageUpdate object type. */
  FABRIC_IMAGE_UPDATE = 30,
  /** PACKET_MIRRORING - Packet mirroring object type. */
  PACKET_MIRRORING = 31,
  /** IMAGE_PACKAGE - Image package object type. */
  IMAGE_PACKAGE = 32,
  /** IPM_CONFIG - Configuration for user-initiated IPM collection. */
  IPM_CONFIG = 33,
  /** NODE_IMAGE_UPDATE - NodeImageUpdate object type. */
  NODE_IMAGE_UPDATE = 34,
  /** NODE_METADATA - NodeMetadata object type. */
  NODE_METADATA = 35,
  /** NOTIFICATION_SETTINGS - The notification settings for a fabric. */
  NOTIFICATION_SETTINGS = 36,
  /** DSCP_CONFIG - The DSCP configs for a fabric. */
  DSCP_CONFIG = 37,
  /** TIER - Tier object type in the fabric design */
  TIER = 38,
  /** SWITCH_GROUP - Switch group type in the fabric design */
  SWITCH_GROUP = 39,
  /** SERVER_GROUP - Server group type in the fabric design */
  SERVER_GROUP = 40,
  /** RAIL_GROUP - Rail group type in the fabric design */
  RAIL_GROUP = 41,
  /** RAIL - Rail type in the fabric design */
  RAIL = 42,
  /** HW_SET - Hardware set type in the fabric design */
  HW_SET = 43,
  /** SWITCH_GROUP_CONN_RULE - Switch group connectivity rule type in the fabric design */
  SWITCH_GROUP_CONN_RULE = 44,
  /** SERVER_GROUP_CONN_RULE - Server group connectivity type in the fabric design */
  SERVER_GROUP_CONN_RULE = 45,
  /** NODE_PORT_CONN_RULE - Node port connectivity rule type in the fabric design */
  NODE_PORT_CONN_RULE = 46,
  /** NODE_PORT_OVERRIDE_RULE - Node port override rule type in the fabric design */
  NODE_PORT_OVERRIDE_RULE = 47,
  /** FABRIC_TEMPLATE - Template for a fabric blueprint */
  FABRIC_TEMPLATE = 48,
  /** IP_SLA_CONFIG - IP SLA config object. */
  IP_SLA_CONFIG = 49,
  /** MULTISITE - Multisite or Datacenter interconnect config. */
  MULTISITE = 50,
  /** SERVER_MGMT_PORT - Server management port config. */
  SERVER_MGMT_PORT = 51,
  /** MULTISITE_CANDIDATE - DCI candidate. */
  MULTISITE_CANDIDATE = 52,
  /** FABRIC_MULTISITE - Fabric multisite object. */
  FABRIC_MULTISITE = 53,
  /** ARS_CONFIG - Configuration for adaptive routing and switching (ARS). */
  ARS_CONFIG = 54,
  /** SWITCH_GROUP_IMAGE_UPDATE - SwitchGroupImageUpdate object type. */
  SWITCH_GROUP_IMAGE_UPDATE = 55,
  /** FABRIC_TARGET_IMAGE_UPDATE - FabricTargetImageUpdate object type. */
  FABRIC_TARGET_IMAGE_UPDATE = 56,
  /** FABRIC_RUNNING_IMAGE_UPDATE - FabricRunningImageUpdate object type. */
  FABRIC_RUNNING_IMAGE_UPDATE = 57,
  /** FABRIC_MAINTENANCE_ON - FabricMaintenanceOn object type. */
  FABRIC_MAINTENANCE_ON = 58,
  /** FABRIC_MAINTENANCE_OFF - FabricMaintenanceOff object type. */
  FABRIC_MAINTENANCE_OFF = 59,
  /** FABRIC_CREDENTIAL - Fabric-scoped credential object type. */
  FABRIC_CREDENTIAL = 60,
  /** DEVICE_IMAGE_UPDATE - DeviceImageUpdate object type. */
  DEVICE_IMAGE_UPDATE = 61,
  /** OSPF_PEER - OSPF peer object type. */
  OSPF_PEER = 62,
  UNRECOGNIZED = -1,
}

export function objectTypeFromJSON(object: any): ObjectType {
  switch (object) {
    case 0:
    case "OBJECT_UNSPECIFIED":
      return ObjectType.OBJECT_UNSPECIFIED;
    case 1:
    case "USER":
      return ObjectType.USER;
    case 2:
    case "TENANT":
      return ObjectType.TENANT;
    case 3:
    case "FABRIC":
      return ObjectType.FABRIC;
    case 4:
    case "NODE":
      return ObjectType.NODE;
    case 5:
    case "NETWORK_PORT":
      return ObjectType.NETWORK_PORT;
    case 6:
    case "PORT_CONNECTION":
      return ObjectType.PORT_CONNECTION;
    case 7:
    case "VLAN":
      return ObjectType.VLAN;
    case 8:
    case "SVI":
      return ObjectType.SVI;
    case 9:
    case "DHCP_RELAY":
      return ObjectType.DHCP_RELAY;
    case 10:
    case "VRF":
      return ObjectType.VRF;
    case 11:
    case "STATIC_ROUTES":
      return ObjectType.STATIC_ROUTES;
    case 12:
    case "PORT_CHANNEL":
      return ObjectType.PORT_CHANNEL;
    case 13:
    case "FABRIC_TRANSACTION":
      return ObjectType.FABRIC_TRANSACTION;
    case 14:
    case "ORGANIZATION":
      return ObjectType.ORGANIZATION;
    case 15:
    case "BEARER_TOKEN":
      return ObjectType.BEARER_TOKEN;
    case 16:
    case "API_KEY":
      return ObjectType.API_KEY;
    case 17:
    case "REST_KEY":
      return ObjectType.REST_KEY;
    case 18:
    case "VNI":
      return ObjectType.VNI;
    case 19:
    case "MANAGEMENT_PORT":
      return ObjectType.MANAGEMENT_PORT;
    case 20:
    case "LOOPBACK":
      return ObjectType.LOOPBACK;
    case 21:
    case "SUB_INTERFACE":
      return ObjectType.SUB_INTERFACE;
    case 22:
    case "PER_VLAN_STP":
      return ObjectType.PER_VLAN_STP;
    case 23:
    case "BGP_PEER":
      return ObjectType.BGP_PEER;
    case 24:
    case "PORT_BREAKOUT":
      return ObjectType.PORT_BREAKOUT;
    case 25:
    case "BGP_POLICY":
      return ObjectType.BGP_POLICY;
    case 26:
    case "PREFIX_LIST":
      return ObjectType.PREFIX_LIST;
    case 27:
    case "DEVICE":
      return ObjectType.DEVICE;
    case 28:
    case "NOTIFICATION_ENDPOINT":
      return ObjectType.NOTIFICATION_ENDPOINT;
    case 29:
    case "CERTIFICATES":
      return ObjectType.CERTIFICATES;
    case 30:
    case "FABRIC_IMAGE_UPDATE":
      return ObjectType.FABRIC_IMAGE_UPDATE;
    case 31:
    case "PACKET_MIRRORING":
      return ObjectType.PACKET_MIRRORING;
    case 32:
    case "IMAGE_PACKAGE":
      return ObjectType.IMAGE_PACKAGE;
    case 33:
    case "IPM_CONFIG":
      return ObjectType.IPM_CONFIG;
    case 34:
    case "NODE_IMAGE_UPDATE":
      return ObjectType.NODE_IMAGE_UPDATE;
    case 35:
    case "NODE_METADATA":
      return ObjectType.NODE_METADATA;
    case 36:
    case "NOTIFICATION_SETTINGS":
      return ObjectType.NOTIFICATION_SETTINGS;
    case 37:
    case "DSCP_CONFIG":
      return ObjectType.DSCP_CONFIG;
    case 38:
    case "TIER":
      return ObjectType.TIER;
    case 39:
    case "SWITCH_GROUP":
      return ObjectType.SWITCH_GROUP;
    case 40:
    case "SERVER_GROUP":
      return ObjectType.SERVER_GROUP;
    case 41:
    case "RAIL_GROUP":
      return ObjectType.RAIL_GROUP;
    case 42:
    case "RAIL":
      return ObjectType.RAIL;
    case 43:
    case "HW_SET":
      return ObjectType.HW_SET;
    case 44:
    case "SWITCH_GROUP_CONN_RULE":
      return ObjectType.SWITCH_GROUP_CONN_RULE;
    case 45:
    case "SERVER_GROUP_CONN_RULE":
      return ObjectType.SERVER_GROUP_CONN_RULE;
    case 46:
    case "NODE_PORT_CONN_RULE":
      return ObjectType.NODE_PORT_CONN_RULE;
    case 47:
    case "NODE_PORT_OVERRIDE_RULE":
      return ObjectType.NODE_PORT_OVERRIDE_RULE;
    case 48:
    case "FABRIC_TEMPLATE":
      return ObjectType.FABRIC_TEMPLATE;
    case 49:
    case "IP_SLA_CONFIG":
      return ObjectType.IP_SLA_CONFIG;
    case 50:
    case "MULTISITE":
      return ObjectType.MULTISITE;
    case 51:
    case "SERVER_MGMT_PORT":
      return ObjectType.SERVER_MGMT_PORT;
    case 52:
    case "MULTISITE_CANDIDATE":
      return ObjectType.MULTISITE_CANDIDATE;
    case 53:
    case "FABRIC_MULTISITE":
      return ObjectType.FABRIC_MULTISITE;
    case 54:
    case "ARS_CONFIG":
      return ObjectType.ARS_CONFIG;
    case 55:
    case "SWITCH_GROUP_IMAGE_UPDATE":
      return ObjectType.SWITCH_GROUP_IMAGE_UPDATE;
    case 56:
    case "FABRIC_TARGET_IMAGE_UPDATE":
      return ObjectType.FABRIC_TARGET_IMAGE_UPDATE;
    case 57:
    case "FABRIC_RUNNING_IMAGE_UPDATE":
      return ObjectType.FABRIC_RUNNING_IMAGE_UPDATE;
    case 58:
    case "FABRIC_MAINTENANCE_ON":
      return ObjectType.FABRIC_MAINTENANCE_ON;
    case 59:
    case "FABRIC_MAINTENANCE_OFF":
      return ObjectType.FABRIC_MAINTENANCE_OFF;
    case 60:
    case "FABRIC_CREDENTIAL":
      return ObjectType.FABRIC_CREDENTIAL;
    case 61:
    case "DEVICE_IMAGE_UPDATE":
      return ObjectType.DEVICE_IMAGE_UPDATE;
    case 62:
    case "OSPF_PEER":
      return ObjectType.OSPF_PEER;
    case -1:
    case "UNRECOGNIZED":
    default:
      return ObjectType.UNRECOGNIZED;
  }
}

export function objectTypeToJSON(object: ObjectType): string {
  switch (object) {
    case ObjectType.OBJECT_UNSPECIFIED:
      return "OBJECT_UNSPECIFIED";
    case ObjectType.USER:
      return "USER";
    case ObjectType.TENANT:
      return "TENANT";
    case ObjectType.FABRIC:
      return "FABRIC";
    case ObjectType.NODE:
      return "NODE";
    case ObjectType.NETWORK_PORT:
      return "NETWORK_PORT";
    case ObjectType.PORT_CONNECTION:
      return "PORT_CONNECTION";
    case ObjectType.VLAN:
      return "VLAN";
    case ObjectType.SVI:
      return "SVI";
    case ObjectType.DHCP_RELAY:
      return "DHCP_RELAY";
    case ObjectType.VRF:
      return "VRF";
    case ObjectType.STATIC_ROUTES:
      return "STATIC_ROUTES";
    case ObjectType.PORT_CHANNEL:
      return "PORT_CHANNEL";
    case ObjectType.FABRIC_TRANSACTION:
      return "FABRIC_TRANSACTION";
    case ObjectType.ORGANIZATION:
      return "ORGANIZATION";
    case ObjectType.BEARER_TOKEN:
      return "BEARER_TOKEN";
    case ObjectType.API_KEY:
      return "API_KEY";
    case ObjectType.REST_KEY:
      return "REST_KEY";
    case ObjectType.VNI:
      return "VNI";
    case ObjectType.MANAGEMENT_PORT:
      return "MANAGEMENT_PORT";
    case ObjectType.LOOPBACK:
      return "LOOPBACK";
    case ObjectType.SUB_INTERFACE:
      return "SUB_INTERFACE";
    case ObjectType.PER_VLAN_STP:
      return "PER_VLAN_STP";
    case ObjectType.BGP_PEER:
      return "BGP_PEER";
    case ObjectType.PORT_BREAKOUT:
      return "PORT_BREAKOUT";
    case ObjectType.BGP_POLICY:
      return "BGP_POLICY";
    case ObjectType.PREFIX_LIST:
      return "PREFIX_LIST";
    case ObjectType.DEVICE:
      return "DEVICE";
    case ObjectType.NOTIFICATION_ENDPOINT:
      return "NOTIFICATION_ENDPOINT";
    case ObjectType.CERTIFICATES:
      return "CERTIFICATES";
    case ObjectType.FABRIC_IMAGE_UPDATE:
      return "FABRIC_IMAGE_UPDATE";
    case ObjectType.PACKET_MIRRORING:
      return "PACKET_MIRRORING";
    case ObjectType.IMAGE_PACKAGE:
      return "IMAGE_PACKAGE";
    case ObjectType.IPM_CONFIG:
      return "IPM_CONFIG";
    case ObjectType.NODE_IMAGE_UPDATE:
      return "NODE_IMAGE_UPDATE";
    case ObjectType.NODE_METADATA:
      return "NODE_METADATA";
    case ObjectType.NOTIFICATION_SETTINGS:
      return "NOTIFICATION_SETTINGS";
    case ObjectType.DSCP_CONFIG:
      return "DSCP_CONFIG";
    case ObjectType.TIER:
      return "TIER";
    case ObjectType.SWITCH_GROUP:
      return "SWITCH_GROUP";
    case ObjectType.SERVER_GROUP:
      return "SERVER_GROUP";
    case ObjectType.RAIL_GROUP:
      return "RAIL_GROUP";
    case ObjectType.RAIL:
      return "RAIL";
    case ObjectType.HW_SET:
      return "HW_SET";
    case ObjectType.SWITCH_GROUP_CONN_RULE:
      return "SWITCH_GROUP_CONN_RULE";
    case ObjectType.SERVER_GROUP_CONN_RULE:
      return "SERVER_GROUP_CONN_RULE";
    case ObjectType.NODE_PORT_CONN_RULE:
      return "NODE_PORT_CONN_RULE";
    case ObjectType.NODE_PORT_OVERRIDE_RULE:
      return "NODE_PORT_OVERRIDE_RULE";
    case ObjectType.FABRIC_TEMPLATE:
      return "FABRIC_TEMPLATE";
    case ObjectType.IP_SLA_CONFIG:
      return "IP_SLA_CONFIG";
    case ObjectType.MULTISITE:
      return "MULTISITE";
    case ObjectType.SERVER_MGMT_PORT:
      return "SERVER_MGMT_PORT";
    case ObjectType.MULTISITE_CANDIDATE:
      return "MULTISITE_CANDIDATE";
    case ObjectType.FABRIC_MULTISITE:
      return "FABRIC_MULTISITE";
    case ObjectType.ARS_CONFIG:
      return "ARS_CONFIG";
    case ObjectType.SWITCH_GROUP_IMAGE_UPDATE:
      return "SWITCH_GROUP_IMAGE_UPDATE";
    case ObjectType.FABRIC_TARGET_IMAGE_UPDATE:
      return "FABRIC_TARGET_IMAGE_UPDATE";
    case ObjectType.FABRIC_RUNNING_IMAGE_UPDATE:
      return "FABRIC_RUNNING_IMAGE_UPDATE";
    case ObjectType.FABRIC_MAINTENANCE_ON:
      return "FABRIC_MAINTENANCE_ON";
    case ObjectType.FABRIC_MAINTENANCE_OFF:
      return "FABRIC_MAINTENANCE_OFF";
    case ObjectType.FABRIC_CREDENTIAL:
      return "FABRIC_CREDENTIAL";
    case ObjectType.DEVICE_IMAGE_UPDATE:
      return "DEVICE_IMAGE_UPDATE";
    case ObjectType.OSPF_PEER:
      return "OSPF_PEER";
    case ObjectType.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

/** OperState defines an enumeration for object's operational states. */
export enum OperState {
  /** OP_STATE_UNSPECIFIED - Invalid operational state. */
  OP_STATE_UNSPECIFIED = 0,
  /** UP - Object's operational state is active. */
  UP = 1,
  /** DOWN - Object's operational state is inactive. */
  DOWN = 2,
  UNRECOGNIZED = -1,
}

export function operStateFromJSON(object: any): OperState {
  switch (object) {
    case 0:
    case "OP_STATE_UNSPECIFIED":
      return OperState.OP_STATE_UNSPECIFIED;
    case 1:
    case "UP":
      return OperState.UP;
    case 2:
    case "DOWN":
      return OperState.DOWN;
    case -1:
    case "UNRECOGNIZED":
    default:
      return OperState.UNRECOGNIZED;
  }
}

export function operStateToJSON(object: OperState): string {
  switch (object) {
    case OperState.OP_STATE_UNSPECIFIED:
      return "OP_STATE_UNSPECIFIED";
    case OperState.UP:
      return "UP";
    case OperState.DOWN:
      return "DOWN";
    case OperState.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

/** Operation defines an enumeration of the types of operations or actions. */
export enum Operation {
  /** OPERATION_UNSPECIFIED - Unspecified operation type. */
  OPERATION_UNSPECIFIED = 0,
  /** CREATE - An object has been added. */
  CREATE = 1,
  /** UPDATE - An object has been updated. */
  UPDATE = 2,
  /** DELETE - An object has been deleted. */
  DELETE = 3,
  /** ENABLE - An object has been enabled. */
  ENABLE = 4,
  /** DISABLE - An object has been disabled. */
  DISABLE = 5,
  /** LOGIN - A user has logged in. */
  LOGIN = 6,
  /** LOGOUT - A user has logged out. */
  LOGOUT = 7,
  /** COMMIT - A transaction has been committed. */
  COMMIT = 8,
  /** REVERT - A transaction has been reverted. */
  REVERT = 9,
  /** BIND - A device has been bound to a blueprint node. */
  BIND = 10,
  /** UNBIND - A switch has been unbound from a blueprint node. */
  UNBIND = 11,
  /** COMMENT - User has added a comment. */
  COMMENT = 12,
  /** ACCEPT - User has reviewed and accepted a config. */
  ACCEPT = 13,
  /** BLOCK - An object has been blocked from cache. */
  BLOCK = 14,
  /** RESTORE - An object has been restored from deleted state. */
  RESTORE = 15,
  UNRECOGNIZED = -1,
}

export function operationFromJSON(object: any): Operation {
  switch (object) {
    case 0:
    case "OPERATION_UNSPECIFIED":
      return Operation.OPERATION_UNSPECIFIED;
    case 1:
    case "CREATE":
      return Operation.CREATE;
    case 2:
    case "UPDATE":
      return Operation.UPDATE;
    case 3:
    case "DELETE":
      return Operation.DELETE;
    case 4:
    case "ENABLE":
      return Operation.ENABLE;
    case 5:
    case "DISABLE":
      return Operation.DISABLE;
    case 6:
    case "LOGIN":
      return Operation.LOGIN;
    case 7:
    case "LOGOUT":
      return Operation.LOGOUT;
    case 8:
    case "COMMIT":
      return Operation.COMMIT;
    case 9:
    case "REVERT":
      return Operation.REVERT;
    case 10:
    case "BIND":
      return Operation.BIND;
    case 11:
    case "UNBIND":
      return Operation.UNBIND;
    case 12:
    case "COMMENT":
      return Operation.COMMENT;
    case 13:
    case "ACCEPT":
      return Operation.ACCEPT;
    case 14:
    case "BLOCK":
      return Operation.BLOCK;
    case 15:
    case "RESTORE":
      return Operation.RESTORE;
    case -1:
    case "UNRECOGNIZED":
    default:
      return Operation.UNRECOGNIZED;
  }
}

export function operationToJSON(object: Operation): string {
  switch (object) {
    case Operation.OPERATION_UNSPECIFIED:
      return "OPERATION_UNSPECIFIED";
    case Operation.CREATE:
      return "CREATE";
    case Operation.UPDATE:
      return "UPDATE";
    case Operation.DELETE:
      return "DELETE";
    case Operation.ENABLE:
      return "ENABLE";
    case Operation.DISABLE:
      return "DISABLE";
    case Operation.LOGIN:
      return "LOGIN";
    case Operation.LOGOUT:
      return "LOGOUT";
    case Operation.COMMIT:
      return "COMMIT";
    case Operation.REVERT:
      return "REVERT";
    case Operation.BIND:
      return "BIND";
    case Operation.UNBIND:
      return "UNBIND";
    case Operation.COMMENT:
      return "COMMENT";
    case Operation.ACCEPT:
      return "ACCEPT";
    case Operation.BLOCK:
      return "BLOCK";
    case Operation.RESTORE:
      return "RESTORE";
    case Operation.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

/** OrgKind lists various organization types. */
export enum OrgKind {
  /** ORG_KIND_UNSPECIFIED - Unspecified organization kind. */
  ORG_KIND_UNSPECIFIED = 0,
  /** REGULAR - Regular organization. */
  REGULAR = 1,
  /** PARKING_LOT - Parking lot organization. */
  PARKING_LOT = 2,
  UNRECOGNIZED = -1,
}

export function orgKindFromJSON(object: any): OrgKind {
  switch (object) {
    case 0:
    case "ORG_KIND_UNSPECIFIED":
      return OrgKind.ORG_KIND_UNSPECIFIED;
    case 1:
    case "REGULAR":
      return OrgKind.REGULAR;
    case 2:
    case "PARKING_LOT":
      return OrgKind.PARKING_LOT;
    case -1:
    case "UNRECOGNIZED":
    default:
      return OrgKind.UNRECOGNIZED;
  }
}

export function orgKindToJSON(object: OrgKind): string {
  switch (object) {
    case OrgKind.ORG_KIND_UNSPECIFIED:
      return "ORG_KIND_UNSPECIFIED";
    case OrgKind.REGULAR:
      return "REGULAR";
    case OrgKind.PARKING_LOT:
      return "PARKING_LOT";
    case OrgKind.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

/** OrgReleaseType defines the release target selection scope of an org */
export enum OrgReleaseType {
  /** ORG_RELEASE_TYPE_UNSPECIFIED - OrgReleaseType unspecified. */
  ORG_RELEASE_TYPE_UNSPECIFIED = 0,
  /**
   * ORG_RELEASE - 1. anything the org is running
   * 2. latest prod-blessed image for the cell pair (does nto include non-blessed)
   * 3. anything the org was running in the last two weeks (make the lookback a configd config int var in days)
   */
  ORG_RELEASE = 1,
  /** ORG_ALL_PUBLISHED - Org may select anything that the cell is aware of. */
  ORG_ALL_PUBLISHED = 2,
  /** ORG_PRERELEASE - Org may select PRERELEASE images. */
  ORG_PRERELEASE = 3,
  UNRECOGNIZED = -1,
}

export function orgReleaseTypeFromJSON(object: any): OrgReleaseType {
  switch (object) {
    case 0:
    case "ORG_RELEASE_TYPE_UNSPECIFIED":
      return OrgReleaseType.ORG_RELEASE_TYPE_UNSPECIFIED;
    case 1:
    case "ORG_RELEASE":
      return OrgReleaseType.ORG_RELEASE;
    case 2:
    case "ORG_ALL_PUBLISHED":
      return OrgReleaseType.ORG_ALL_PUBLISHED;
    case 3:
    case "ORG_PRERELEASE":
      return OrgReleaseType.ORG_PRERELEASE;
    case -1:
    case "UNRECOGNIZED":
    default:
      return OrgReleaseType.UNRECOGNIZED;
  }
}

export function orgReleaseTypeToJSON(object: OrgReleaseType): string {
  switch (object) {
    case OrgReleaseType.ORG_RELEASE_TYPE_UNSPECIFIED:
      return "ORG_RELEASE_TYPE_UNSPECIFIED";
    case OrgReleaseType.ORG_RELEASE:
      return "ORG_RELEASE";
    case OrgReleaseType.ORG_ALL_PUBLISHED:
      return "ORG_ALL_PUBLISHED";
    case OrgReleaseType.ORG_PRERELEASE:
      return "ORG_PRERELEASE";
    case OrgReleaseType.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

/** OsType defines an enumeration of various device operating system types. */
export enum OsType {
  /** OS_UNSPECIFIED - Unspecified OS type. */
  OS_UNSPECIFIED = 0,
  /** HYPER_FABRIC - Cisco Nexus Hyperfabric OS. */
  HYPER_FABRIC = 1,
  /** NEXUS - Cisco Nexus OS. */
  NEXUS = 2,
  /** IOS_XE - Cisco IOS-XE OS. */
  IOS_XE = 3,
  /** IOS_XR - Cisco IOS-XR OS. */
  IOS_XR = 4,
  /** LINUX - Linux OS (host OS). */
  LINUX = 5,
  /** WINDOWS - Windows OS (host OS). */
  WINDOWS = 6,
  UNRECOGNIZED = -1,
}

export function osTypeFromJSON(object: any): OsType {
  switch (object) {
    case 0:
    case "OS_UNSPECIFIED":
      return OsType.OS_UNSPECIFIED;
    case 1:
    case "HYPER_FABRIC":
      return OsType.HYPER_FABRIC;
    case 2:
    case "NEXUS":
      return OsType.NEXUS;
    case 3:
    case "IOS_XE":
      return OsType.IOS_XE;
    case 4:
    case "IOS_XR":
      return OsType.IOS_XR;
    case 5:
    case "LINUX":
      return OsType.LINUX;
    case 6:
    case "WINDOWS":
      return OsType.WINDOWS;
    case -1:
    case "UNRECOGNIZED":
    default:
      return OsType.UNRECOGNIZED;
  }
}

export function osTypeToJSON(object: OsType): string {
  switch (object) {
    case OsType.OS_UNSPECIFIED:
      return "OS_UNSPECIFIED";
    case OsType.HYPER_FABRIC:
      return "HYPER_FABRIC";
    case OsType.NEXUS:
      return "NEXUS";
    case OsType.IOS_XE:
      return "IOS_XE";
    case OsType.IOS_XR:
      return "IOS_XR";
    case OsType.LINUX:
      return "LINUX";
    case OsType.WINDOWS:
      return "WINDOWS";
    case OsType.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

/** PackageName defines an enumeration of the names of the image packages */
export enum PackageName {
  /** PACKAGE_NAME_UNSPECIFIED - Unspecified package name */
  PACKAGE_NAME_UNSPECIFIED = 0,
  /** AGENTS - The agent package */
  AGENTS = 1,
  /** SWSS - The sonic image type name */
  SWSS = 2,
  /** BOOTLOADER - The bootloader package */
  BOOTLOADER = 3,
  /** BOOTLOADERCFG - The bootloadercfg package */
  BOOTLOADERCFG = 4,
  /** KERNEL - The kernel package */
  KERNEL = 5,
  /** MONOLITH - The monolith package */
  MONOLITH = 6,
  /** DOCKERFS - The dockerfs package */
  DOCKERFS = 7,
  /** INITRD - The initrd package */
  INITRD = 8,
  /** AGENT_CONTAINER - The agent container package */
  AGENT_CONTAINER = 9,
  /** NEXUS_OS - The Cisco Nexus OS package */
  NEXUS_OS = 10,
  /** OPTICS_FIRMWARE - The optics firmware package */
  OPTICS_FIRMWARE = 11,
  UNRECOGNIZED = -1,
}

export function packageNameFromJSON(object: any): PackageName {
  switch (object) {
    case 0:
    case "PACKAGE_NAME_UNSPECIFIED":
      return PackageName.PACKAGE_NAME_UNSPECIFIED;
    case 1:
    case "AGENTS":
      return PackageName.AGENTS;
    case 2:
    case "SWSS":
      return PackageName.SWSS;
    case 3:
    case "BOOTLOADER":
      return PackageName.BOOTLOADER;
    case 4:
    case "BOOTLOADERCFG":
      return PackageName.BOOTLOADERCFG;
    case 5:
    case "KERNEL":
      return PackageName.KERNEL;
    case 6:
    case "MONOLITH":
      return PackageName.MONOLITH;
    case 7:
    case "DOCKERFS":
      return PackageName.DOCKERFS;
    case 8:
    case "INITRD":
      return PackageName.INITRD;
    case 9:
    case "AGENT_CONTAINER":
      return PackageName.AGENT_CONTAINER;
    case 10:
    case "NEXUS_OS":
      return PackageName.NEXUS_OS;
    case 11:
    case "OPTICS_FIRMWARE":
      return PackageName.OPTICS_FIRMWARE;
    case -1:
    case "UNRECOGNIZED":
    default:
      return PackageName.UNRECOGNIZED;
  }
}

export function packageNameToJSON(object: PackageName): string {
  switch (object) {
    case PackageName.PACKAGE_NAME_UNSPECIFIED:
      return "PACKAGE_NAME_UNSPECIFIED";
    case PackageName.AGENTS:
      return "AGENTS";
    case PackageName.SWSS:
      return "SWSS";
    case PackageName.BOOTLOADER:
      return "BOOTLOADER";
    case PackageName.BOOTLOADERCFG:
      return "BOOTLOADERCFG";
    case PackageName.KERNEL:
      return "KERNEL";
    case PackageName.MONOLITH:
      return "MONOLITH";
    case PackageName.DOCKERFS:
      return "DOCKERFS";
    case PackageName.INITRD:
      return "INITRD";
    case PackageName.AGENT_CONTAINER:
      return "AGENT_CONTAINER";
    case PackageName.NEXUS_OS:
      return "NEXUS_OS";
    case PackageName.OPTICS_FIRMWARE:
      return "OPTICS_FIRMWARE";
    case PackageName.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

/** An SBP subscription update may come from one of multiple pools. */
export enum SbpPool {
  SBP_POOL_UNSPECIFIED = 0,
  /** PRODUCTION - Pool of SBP production subscriptions. */
  PRODUCTION = 1,
  /** PRODUCTION_TEST - Pool of SBP production test subscriptions. */
  PRODUCTION_TEST = 2,
  /** STAGING - Pool of SBP staging subscriptions. */
  STAGING = 3,
  /** STAGING_TEST - Pool of SBP staging test subscriptions. */
  STAGING_TEST = 4,
  /** INTERNAL - Pool of subscriptions created internally. */
  INTERNAL = 5,
  UNRECOGNIZED = -1,
}

export function sbpPoolFromJSON(object: any): SbpPool {
  switch (object) {
    case 0:
    case "SBP_POOL_UNSPECIFIED":
      return SbpPool.SBP_POOL_UNSPECIFIED;
    case 1:
    case "PRODUCTION":
      return SbpPool.PRODUCTION;
    case 2:
    case "PRODUCTION_TEST":
      return SbpPool.PRODUCTION_TEST;
    case 3:
    case "STAGING":
      return SbpPool.STAGING;
    case 4:
    case "STAGING_TEST":
      return SbpPool.STAGING_TEST;
    case 5:
    case "INTERNAL":
      return SbpPool.INTERNAL;
    case -1:
    case "UNRECOGNIZED":
    default:
      return SbpPool.UNRECOGNIZED;
  }
}

export function sbpPoolToJSON(object: SbpPool): string {
  switch (object) {
    case SbpPool.SBP_POOL_UNSPECIFIED:
      return "SBP_POOL_UNSPECIFIED";
    case SbpPool.PRODUCTION:
      return "PRODUCTION";
    case SbpPool.PRODUCTION_TEST:
      return "PRODUCTION_TEST";
    case SbpPool.STAGING:
      return "STAGING";
    case SbpPool.STAGING_TEST:
      return "STAGING_TEST";
    case SbpPool.INTERNAL:
      return "INTERNAL";
    case SbpPool.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

/** SigningKeyType defines an enumeration for the type of signing key used in services like Brig, Fred. */
export enum SigningKeyType {
  SIGNING_KEY_TYPE_UNSPECIFIED = 0,
  /**
   * SIGNING_KEY_TYPE_CSRF - CSRF key type
   *
   * @deprecated
   */
  SIGNING_KEY_TYPE_CSRF = 1,
  /** SIGNING_KEY_TYPE_SSO - SSO key type */
  SIGNING_KEY_TYPE_SSO = 2,
  /** SIGNING_KEY_TYPE_USER_JWT - User JWT key type */
  SIGNING_KEY_TYPE_USER_JWT = 3,
  /** SIGNING_KEY_TYPE_AGENT_JWT - Agent JWT key type */
  SIGNING_KEY_TYPE_AGENT_JWT = 4,
  UNRECOGNIZED = -1,
}

export function signingKeyTypeFromJSON(object: any): SigningKeyType {
  switch (object) {
    case 0:
    case "SIGNING_KEY_TYPE_UNSPECIFIED":
      return SigningKeyType.SIGNING_KEY_TYPE_UNSPECIFIED;
    case 1:
    case "SIGNING_KEY_TYPE_CSRF":
      return SigningKeyType.SIGNING_KEY_TYPE_CSRF;
    case 2:
    case "SIGNING_KEY_TYPE_SSO":
      return SigningKeyType.SIGNING_KEY_TYPE_SSO;
    case 3:
    case "SIGNING_KEY_TYPE_USER_JWT":
      return SigningKeyType.SIGNING_KEY_TYPE_USER_JWT;
    case 4:
    case "SIGNING_KEY_TYPE_AGENT_JWT":
      return SigningKeyType.SIGNING_KEY_TYPE_AGENT_JWT;
    case -1:
    case "UNRECOGNIZED":
    default:
      return SigningKeyType.UNRECOGNIZED;
  }
}

export function signingKeyTypeToJSON(object: SigningKeyType): string {
  switch (object) {
    case SigningKeyType.SIGNING_KEY_TYPE_UNSPECIFIED:
      return "SIGNING_KEY_TYPE_UNSPECIFIED";
    case SigningKeyType.SIGNING_KEY_TYPE_CSRF:
      return "SIGNING_KEY_TYPE_CSRF";
    case SigningKeyType.SIGNING_KEY_TYPE_SSO:
      return "SIGNING_KEY_TYPE_SSO";
    case SigningKeyType.SIGNING_KEY_TYPE_USER_JWT:
      return "SIGNING_KEY_TYPE_USER_JWT";
    case SigningKeyType.SIGNING_KEY_TYPE_AGENT_JWT:
      return "SIGNING_KEY_TYPE_AGENT_JWT";
    case SigningKeyType.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

/** TaskType defines an enumeration of various workflow tasks. */
export enum TaskType {
  /** TASK_TYPE_UNSPECIFIED - Unspecified task type. */
  TASK_TYPE_UNSPECIFIED = 0,
  /** TASK_TESTING - Tasks used for testing and verifying workflows. */
  TASK_TESTING = 1,
  /** TASK_SONIC - Workflow tasks for SONiC. */
  TASK_SONIC = 2,
  /** TASK_NEXUS - Workflow tasks for Nexus. */
  TASK_NEXUS = 3,
  UNRECOGNIZED = -1,
}

export function taskTypeFromJSON(object: any): TaskType {
  switch (object) {
    case 0:
    case "TASK_TYPE_UNSPECIFIED":
      return TaskType.TASK_TYPE_UNSPECIFIED;
    case 1:
    case "TASK_TESTING":
      return TaskType.TASK_TESTING;
    case 2:
    case "TASK_SONIC":
      return TaskType.TASK_SONIC;
    case 3:
    case "TASK_NEXUS":
      return TaskType.TASK_NEXUS;
    case -1:
    case "UNRECOGNIZED":
    default:
      return TaskType.UNRECOGNIZED;
  }
}

export function taskTypeToJSON(object: TaskType): string {
  switch (object) {
    case TaskType.TASK_TYPE_UNSPECIFIED:
      return "TASK_TYPE_UNSPECIFIED";
    case TaskType.TASK_TESTING:
      return "TASK_TESTING";
    case TaskType.TASK_SONIC:
      return "TASK_SONIC";
    case TaskType.TASK_NEXUS:
      return "TASK_NEXUS";
    case TaskType.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

/** A user_type could be from regular added users or imported support users. */
export enum UserType {
  USER_TYPE_UNSPECIFIED = 0,
  /** USER_TYPE_REGULAR - User added through regular way. */
  USER_TYPE_REGULAR = 1,
  /** USER_TYPE_TAC - User imported through TAC (Technical Assistance Center). */
  USER_TYPE_TAC = 2,
  UNRECOGNIZED = -1,
}

export function userTypeFromJSON(object: any): UserType {
  switch (object) {
    case 0:
    case "USER_TYPE_UNSPECIFIED":
      return UserType.USER_TYPE_UNSPECIFIED;
    case 1:
    case "USER_TYPE_REGULAR":
      return UserType.USER_TYPE_REGULAR;
    case 2:
    case "USER_TYPE_TAC":
      return UserType.USER_TYPE_TAC;
    case -1:
    case "UNRECOGNIZED":
    default:
      return UserType.UNRECOGNIZED;
  }
}

export function userTypeToJSON(object: UserType): string {
  switch (object) {
    case UserType.USER_TYPE_UNSPECIFIED:
      return "USER_TYPE_UNSPECIFIED";
    case UserType.USER_TYPE_REGULAR:
      return "USER_TYPE_REGULAR";
    case UserType.USER_TYPE_TAC:
      return "USER_TYPE_TAC";
    case UserType.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

/**
 * Annotation defines a typed name/value pair to store user-defined data
 * including complex data such as JSON.
 */
export interface Annotation {
  /** The user-defined name used to uniquely identify the annotation. */
  name: string;
  /** The value of the annotation expressed as a string. */
  value: string;
  /** The type of data stored in the value of the annotation. */
  dataType: DataType;
}

function createBaseAnnotation(): Annotation {
  return { name: "", value: "", dataType: 0 };
}

export const Annotation: MessageFns<Annotation> = {
  encode(message: Annotation, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.name !== "") {
      writer.uint32(10).string(message.name);
    }
    if (message.value !== "") {
      writer.uint32(18).string(message.value);
    }
    if (message.dataType !== 0) {
      writer.uint32(24).int32(message.dataType);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): Annotation {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseAnnotation();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.name = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.value = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.dataType = reader.int32() as any;
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): Annotation {
    return {
      name: isSet(object.name) ? globalThis.String(object.name) : "",
      value: isSet(object.value) ? globalThis.String(object.value) : "",
      dataType: isSet(object.dataType) ? dataTypeFromJSON(object.dataType) : 0,
    };
  },

  toJSON(message: Annotation): unknown {
    const obj: any = {};
    if (message.name !== "") {
      obj.name = message.name;
    }
    if (message.value !== "") {
      obj.value = message.value;
    }
    if (message.dataType !== 0) {
      obj.dataType = dataTypeToJSON(message.dataType);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<Annotation>, I>>(base?: I): Annotation {
    return Annotation.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<Annotation>, I>>(object: I): Annotation {
    const message = createBaseAnnotation();
    message.name = object.name ?? "";
    message.value = object.value ?? "";
    message.dataType = object.dataType ?? 0;
    return message;
  },
};

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

type KeysOfUnion<T> = T extends T ? keyof T : never;
export type Exact<P, I extends P> = P extends Builtin ? P
  : P & { [K in keyof P]: Exact<P[K], I[K]> } & { [K in Exclude<keyof I, KeysOfUnion<P>>]: never };

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}

export interface MessageFns<T> {
  encode(message: T, writer?: BinaryWriter): BinaryWriter;
  decode(input: BinaryReader | Uint8Array, length?: number): T;
  fromJSON(object: any): T;
  toJSON(message: T): unknown;
  create<I extends Exact<DeepPartial<T>, I>>(base?: I): T;
  fromPartial<I extends Exact<DeepPartial<T>, I>>(object: I): T;
}
